import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";

import { colors, FromTopPage, GridWrapper, Button } from "../../theme";
import bgMLetterBottom from "../../assets/bg-mletter-header.png";
import bgMLetterTop from "../../assets/bg-mletter-header-top.svg";

export const SupportContainer = styled(FromTopPage)`
  background: url(${bgMLetterTop}) top right, url(${bgMLetterBottom});
  background-repeat: no-repeat;
  background-size: auto 370px, 100% 370px;
  padding-top: 70px;
  text-align: center;

  @media (max-width: 1023px) {
    padding-top: 40px;
  }

  > h1 {
    color: black;
    font-size: 6.4rem;
    font-weight: 600;
    margin-bottom: 16px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      font-size: 5.4rem;
    }

    @media (max-width: 767px) {
      font-size: 3.4rem;
    }

    span {
      font-weight: 100;
    }

    + p {
      line-height: 2.8rem;
      margin: auto;
      text-align: center;
      width: 768px;

      @media (max-width: 1023px) {
        padding: 0 50px;
        width: 100%;
      }

      @media (max-width: 767px) {
        display: none;
      }
    }
  }
`;

export const SupportContent = styled(GridWrapper)`
  display: flex;
  justify-content: space-between;
  margin-top: 46px;

  @media (max-width: 1023px) {
    margin-top: 32px;
  }
`;

const SupportBlock = styled.div`
  background: white;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
`;

export const SupportMain = styled(SupportBlock)`
  padding: 48px 80px 50px;
  position: relative;
  width: 814px;
  z-index: 1;

  @media (max-width: 1599px) {
    padding: 48px 60px 50px;
    width: 584px;
  }

  @media (max-width: 1023px) {
    display: block;
    width: 100%;
  }

  @media (max-width: 767px) {
    padding: 35px;
  }

  h2 {
    color: black;
    font-weight: 500;
    font-size: 2.8rem;
    letter-spacing: -0.02rem;
    margin-bottom: 35px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      font-size: 2rem;
      margin-bottom: 25px;
    }
  }

  button {
    margin-top: 45px;

    @media (max-width: 1023px) {
      margin-top: 35px;
    }
  }
`;

export const SupportAside = styled.aside`
  width: 340px;

  @media (max-width: 1599px) {
    width: 286px;
  }

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const Offer = styled(SupportBlock)`
  padding: 30px 25px;
  position: relative;
  text-align: center;
  width: 340px;

  @media (max-width: 1599px) {
    width: 286px;
  }

  h3 {
    color: black;
    font-size: 2.4rem;
    font-weight: 500;
    margin: 20px 0;
    text-transform: uppercase;

    ${(props) =>
      props.isSocioPath &&
      !props.isResubscribing &&
      `
      margin: 4px 0;

      @media (max-width: 1599px) {
        margin: 6px 0;
      }

      + p {
        color: ${colors.lightTextColor};
        margin-bottom: 14px;
        text-transform: uppercase;

        @media (max-width: 1599px) {
          font-size: 1.3rem;
        }
      }
    `}
  }

  > ul {
    list-style: none;
    margin: 25px 10px 30px;
    padding: 0;
    text-align: left;

    @media (max-width: 1599px) {
      margin: 20px 0 25px;
    }
  }

  li {
    margin-bottom: 10px;
  }

  i {
    color: ${colors.green};
    margin-right: 8px;

    @media (max-width: 1599px) {
      margin-right: 4px;
    }
  }

  > div {
    background: ${colors.lightGray};
    padding: 20px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0 0 0 20px;
      text-align: left;
    }
  }
`;

export const OfferTitle = styled.h2`
  background: ${(props) => props.color};
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  left: 50%;
  padding: 8px 27px;
  position: absolute;
  top: -14px;
  transform: translateX(-50%);
  white-space: nowrap;
`;

export const OfferButton = styled(Button)`
  font-size: 1.4rem;
  padding: 13px 20px;
  width: 100%;
`;

export const More = styled(ScrollLink)`
  cursor: pointer;
  display: inline-block;
  margin: 20px 0;
  text-decoration: underline;
  transition: 0.3s;

  :hover {
    color: ${colors.primaryColor};
  }
`;
